// extracted by mini-css-extract-plugin
export default {"remove":"BlacklistModal_remove__6thQH","buttons":"BlacklistModal_buttons__LatOm","add":"BlacklistModal_add__MmXI0","motivation":"BlacklistModal_motivation__z4Imf"};